import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import DonutChart from '../../../components/common/DonutChart';
import Preloader from '../../../components/common/Preloader';
import { getTotalStats } from '../../../modules/events/selectors';

export const MatchStats = ({ stats }) => {
  if (!stats) {
    return (
      <div className="match-stats">
        <div className="match-stats__box">
          <Preloader>Waiting for stats...</Preloader>
        </div>
      </div>
    );
  }
  return (
    <div className="match-stats">
      <div className="match-stats__box">
        <div className="match-stats__label match-stats__label--top">Possesion</div>
        <div className="match-stats__number-stats">
          <div className="match-stats__home-value">
            {stats.possessionPercent.home}
            <span className="match-stats__percent match-stats__percent--small" />
          </div>
          <div className="match-stats__chart">
            <DonutChart values={[stats.possessionPercent.away, stats.possessionPercent.home]} />
            <div className="match-stats__chart-label">
              <span className="match-stats__percent" />
            </div>
          </div>
          <div className="match-stats__away-value">
            {stats.possessionPercent.away}
            <span className="match-stats__percent match-stats__percent--small" />
          </div>
        </div>
      </div>
      <div className="match-stats__box">
        <div className="match-stats__number-stats">
          <div className="match-stats__home-value">{stats.shotsTotal.home}</div>
          <div className="match-stats__label">Total Shots</div>
          <div className="match-stats__away-value">{stats.shotsTotal.away}</div>
        </div>
      </div>
      <div className="match-stats__box match-stats__box--with-gate">
        <div className="match-stats__number-stats">
          <div className="match-stats__home-value match-stats__home-value--small">
            {stats.shotsOffTarget.home}
          </div>
          <div className="match-stats__label">Shots off Target</div>
          <div className="match-stats__away-value match-stats__away-value--small">
            {stats.shotsOffTarget.away}
          </div>
        </div>
        <div className="match-stats__gate">
          <div className="match-stats__label match-stats__label--top">Shots on Target</div>
          <div className="match-stats__home-value match-stats__home-value--small">
            {stats.shotsOnTarget.home}
          </div>
          <div className="match-stats__away-value match-stats__away-value--small">
            {stats.shotsOnTarget.away}
          </div>
        </div>
      </div>
      <div className="match-stats__box">
        <div className="match-stats__label match-stats__label--top">Shot Accuracy</div>
        <div className="match-stats__number-stats">
          <div className="match-stats__home-value match-stats__home-value--small">
            <div className="match-stats__chart">
              <DonutChart
                values={[stats.shotAccuracy.home]}
                slicesClassNames={['donut-chart__slice--navy']}
              />
              <div className="match-stats__chart-label">
                {stats.shotAccuracy.home}
                <span className="match-stats__percent match-stats__percent--xsmall" />
              </div>
            </div>
          </div>
          <div className="match-stats__away-value match-stats__away-value--small">
            <div className="match-stats__chart">
              <DonutChart values={[stats.shotAccuracy.away]} />
              <div className="match-stats__chart-label">
                {stats.shotAccuracy.away}
                <span className="match-stats__percent match-stats__percent--xsmall" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="match-stats__box">
        <div className="match-stats__number-stats">
          <div className="match-stats__home-value">{stats.corners.home}</div>
          <div className="match-stats__label">Corners</div>
          <div className="match-stats__away-value">{stats.corners.away}</div>
        </div>
      </div>
      <div className="match-stats__box">
        <div className="match-stats__number-stats">
          <div className="match-stats__home-value">{stats.totalCards.home}</div>
          <div className="match-stats__label">Cards</div>
          <div className="match-stats__away-value">{stats.totalCards.away}</div>
        </div>
      </div>
    </div>
  );
};

MatchStats.propTypes = {
  stats: PropTypes.object
};

const mapStateToProps = (state, props) => ({
  stats: getTotalStats(state, props)
});

export default connect(mapStateToProps)(MatchStats);
